export const contactsData = {
    email: '4adhi007@gmail.com',
    phone: '+919947800749',
    address: 'Model Engineering College, Ernakulam, Kerala, India',

    sheetAPI: ''
}